import React from 'react';
import ContactBanner from './ContactBanner';
import ContactInfo from 'pages/ContactUs/ContactInfo/ContactInfo';
import AddressFooter from 'Utils/AddressFooter';
import styles from './ContactUsPage.module.css';

const ContactUsPage = () => (
  <main className={styles.container}>
    <div className={styles.contentWrapper}>
      <ContactBanner />
      <ContactInfo />
    </div>
    <AddressFooter />
  </main>
);

export default ContactUsPage;
